import { useQuery } from '@tanstack/react-query';
import { GetTimesheetsRequest } from 'src/api/FiretrolApiClient';
import { timesheetApiClient } from 'src/api/FiretrolApiClientInstances';
import { queryKeys } from 'src/api/queries/queryKeys';
import { toCancelToken } from 'src/api/queries/queryClient';

export type TimesheetAdminListParams = Omit<GetTimesheetsRequest, 'officeId'>;

/** @registry Office-wide timesheet list backing one workflow-step tab on the Time page. */
export function useTimesheetAdminList(
  officeId: number | null | undefined,
  params: TimesheetAdminListParams,
) {
  return useQuery({
    queryKey: queryKeys.timesheets.adminList(officeId ?? -1, params),
    queryFn: ({ signal }) =>
      timesheetApiClient.getTimesheets(
        { officeId: officeId!, ...params },
        toCancelToken(signal),
      ),
    enabled: officeId != null && officeId > 0,
    staleTime: 0,
    meta: { errorContext: 'office timesheets' },
  });
}
